export const FETCH_LOCATIONS_REQUEST = 'location/FETCH_LOCATIONS_REQUEST';
export const FETCH_LOCATIONS_SUCCESS = 'location/FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_FAILURE = 'location/FETCH_LOCATIONS_FAILURE';

export const FETCH_CURRENT_LOCATION_REQUEST = 'booking/FETCH_CURRENT_LOCATION_REQUEST';
export const FETCH_CURRENT_LOCATION_SUCCESS = 'booking/FETCH_CURRENT_LOCATION_SUCCESS';
export const FETCH_CURRENT_LOCATION_FAILURE = 'booking/FETCH_CURRENT_LOCATION_FAILURE';
